module.exports = __webpack_public_path__ + "img/google-icon.0b50e4b8.png";